// urls.py serves both spellings, since the browser drops the fragment on a 301.
const AUTH_CALLBACK_PATHS = ['/auth/callback', '/auth/callback/'];
const PASSKEY_SETUP_PATH = '/passkey-setup';
const NONCE_PARAM = 'nonce';
const PASSKEY_SETUP_TOKEN_PARAM = 'token';

let stashed: Record<string, string> | null = null;
let passkeySetupToken: string | null = null;
let secretStillInUrl = false;

function liftFragment(secretParam: string): Record<string, string> {
  const hash = window.location.hash;
  const stripped = hash.startsWith('#') ? hash.slice(1) : hash;
  if (!stripped) return {};

  const params: Record<string, string> = {};
  new URLSearchParams(stripped).forEach((value, key) => {
    params[key] = value;
  });
  try {
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  } catch {
    // Boot path for every social login and passkey setup: a refused strip must not white-screen the app.
    // The secret is still in the href, so analytics must not boot and stamp it.
    secretStillInUrl = Boolean(params[secretParam]);
  }
  return params;
}

// Called from authUrlPreflight before PostHog and Datadog RUM start, both of which stamp
// the full href on every event they send.
export function captureAuthCallbackParams(): void {
  const { pathname } = window.location;
  if (AUTH_CALLBACK_PATHS.includes(pathname)) {
    stashed = liftFragment(NONCE_PARAM);
  } else if (pathname === PASSKEY_SETUP_PATH) {
    passkeySetupToken = liftFragment(PASSKEY_SETUP_TOKEN_PARAM)[PASSKEY_SETUP_TOKEN_PARAM] ?? '';
  }
}

// True when the fragment could not be stripped, so any SDK that stamps the current URL
// would send the login nonce or setup token with every event. Fail closed: skip analytics for this load.
export function authFragmentStripFailed(): boolean {
  return secretStillInUrl;
}

// Falls back to the live fragment so a mount that bypassed the preflight still logs in.
export function consumeAuthCallbackParams(): Record<string, string> {
  if (stashed === null) return liftFragment(NONCE_PARAM);
  const params = stashed;
  stashed = null;
  return params;
}

// Not consumed on read: StrictMode and remounts read it again, and the server enforces single use.
export function getPasskeySetupToken(): string {
  if (passkeySetupToken === null) {
    passkeySetupToken = liftFragment(PASSKEY_SETUP_TOKEN_PARAM)[PASSKEY_SETUP_TOKEN_PARAM] ?? '';
  }
  return passkeySetupToken;
}
